module.exports = __webpack_public_path__ + "img/premium-key-vertical.9b63490c.svg";